module.exports = __webpack_public_path__ + "img/pax.08ce9661.svg";